// @flow
import type { HiveAction } from '~/core/types/beekeeper';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import SVGIcon from '~/core/icons/svg-icons';
import Action from './action';
import messages from './intl';
import { CreateAction, PlusContainer, NumberActions, NumberText } from './styles';
import DiscoverActions from './discover-splash';
import LoadingIndicator from '~/components/widgets/indicators/loading';
import { TAB_KEY, TAB_DISCOVER } from '../constants';

type Props = {
    actions: Array<HiveAction>,
    isLoading: boolean,
    productId: ?string,
    removeAction: (string, string, ?boolean) => void
};
const MyActions = ({ actions, isLoading, productId, removeAction }: Props) => (
    <div>
        <LoadingIndicator isLoading={isLoading}>
            {actions.length === 0 && !productId ? (
                <DiscoverActions />
            ) : (
                [
                    <CreateAction key="create-action" to={{ search: `?${TAB_KEY}=${TAB_DISCOVER}` }}>
                        <PlusContainer>
                            <SVGIcon type={generalIcons.PLUS} />
                        </PlusContainer>
                        <FormattedMessage {...messages.createAction} />
                    </CreateAction>,
                    <NumberActions key="number-actions">
                        <FormattedMessage {...messages.numberAction} values={{ amount: actions.length }} />{' '}
                        <NumberText>{actions.length}</NumberText>
                    </NumberActions>,
                    actions.map(action => (
                        <Action
                            action={action}
                            key={action.id}
                            removeAction={(deprecated = false) => removeAction(action.id, action.name, deprecated)}
                        />
                    ))
                ]
            )}
        </LoadingIndicator>
    </div>
);

export default MyActions;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/component.js